export const NORWEGIAN_REGIONS = [
  'Oslo',
  'Akershus',
  'Østfold',
  'Buskerud',
  'Innlandet',
  'Vestfold',
  'Telemark',
  'Agder',
  'Rogaland',
  'Vestland',
  'Møre og Romsdal',
  'Trøndelag',
  'Nordland',
  'Troms',
  'Finnmark',
];
